import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { changeRecoveryPassword } from "../../redux/actions/auth";
import CambiarClaveRecuperacion from "./CambiarClaveRecuperacion";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const CambiarClaveRecuperacionContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const usuario = query.get("usuario") || "";

  const handleSubmit = (values) => {
    const payload = {
      usuario: usuario || values.usuario,
      claveRecuperacion: values.claveRecuperacion,
      claveNueva: values.claveNueva,
    };
    dispatch(changeRecoveryPassword(payload)).then(() => {
      toast.success("Contraseña cambiada correctamente.")
      navigate("/");
    })
  };

  return <CambiarClaveRecuperacion handleSubmit={handleSubmit} defaultUsuario={usuario} />;
};

export default CambiarClaveRecuperacionContainer;
